import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2dd2e111&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./styles/list.scss?vue&type=style&index=0&id=2dd2e111&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2e111",
  null
  
)

export default component.exports